import { Grid2, Typography } from "@mui/material";
import { useTranslate } from "../../../hooks/useTranslate";
import "./Support.css";
import { isVersionUK } from "../../../services/versionService";

const Support = () => {
    const { t } = useTranslate();

    return (
        <div className="page-content support-page">
            <Grid2 container spacing={2}>
                <Grid2 size={{ xs: 12 }}>
                    <Typography variant="h1">
                        {t("support.title")}
                    </Typography>
                    <Typography variant="body1" className="support-page__text mt-4" component="div">
                        {t("support.description")}
                        {isVersionUK && (
                            <>
                                <a href="https://kingsinterhigh.co.uk/contact" target="_blank" rel="noreferrer">{t("support.here")}</a>
                                <br />
                                <br />
                                {t("support.description2")}
                            </>
                        )}
                    </Typography>
                </Grid2>
            </Grid2>
        </div>
    );
};

export default Support;
